import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserSimple } from '../../../models';
import { AppointmentFormDTO } from '../../../models/appointment';

export type Appointment = any;

@Injectable({ providedIn: 'root' })
export class ArrangeAppointmentService {
  client: any;
  currentAdvisor: UserSimple;
  currentAppointment: Appointment;

  get editMode() {
    return this.currentAppointment && !['CANCELED', 'PASSED'].includes(this.currentAppointment.state);
  }

  isFactFindRequestAllowed: boolean;

  noSubmitMode = false;
  appointmentSelected$ = new Subject<AppointmentFormDTO>();
  appointmentSubmitted$ = new Subject();
  initialAppointment?: Appointment;
}
